
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M10.65 16.12h128.7v13.32H10.65zM132.58 39.02H17.41l-4.12-9.57h123.9l-4.61 9.57zM124.56 39.51h8.02v94.37h-8.02zM17.46 39.26h8.02v94.37h-8.02zM25.7 56.99h98.86M25.7 74.1h98.86M25.7 91.22h98.86M25.7 108.33h98.86M25.7 124.28h98.86"}})])
          )
        }
      }
    